import React from 'react';
import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

const extractDimensionCode = (value) => {
    const match = String(value || '').toUpperCase().match(/D[1-7]/);
    return match ? match[0] : String(value || '');
};

const ResumeRadarSelfcare = ({ dimensions, globalDimensions }) => {
    if (!dimensions || dimensions.length === 0) return null;

    const globalLookup = {};
    if (globalDimensions && globalDimensions.length > 0) {
        globalDimensions.forEach((dim) => {
            const code = extractDimensionCode(dim.code || dim.key || dim.title);
            globalLookup[code] = Number.isFinite(Number(dim.average)) ? Number(dim.average) : 0;
        });
    }
    const hasGlobal = Object.keys(globalLookup).length > 0;

    const radarData = dimensions.map((dim) => {
        const code = extractDimensionCode(dim.code || dim.key || dim.title);
        return {
            subject: code,
            fullName: dim.reportTitle || dim.title,
            value: Number.isFinite(Number(dim.average)) ? Number(dim.average) : 0,
            ...(hasGlobal ? { global: globalLookup[code] ?? 0 } : {}),
        };
    });

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const item = payload[0]?.payload;
            return (
                <div style={{ backgroundColor: 'white', padding: 10, border: '1px solid #ccc' }}>
                    <div style={{ fontWeight: 700 }}>{item?.subject}</div>
                    <div style={{ fontSize: 11, color: '#5b5b5b' }}>{item?.fullName}</div>
                    <div style={{ fontWeight: 600, color: '#ff7a00' }}>Individual: {item?.value}%</div>
                    {hasGlobal && item?.global != null && (
                        <div style={{ fontWeight: 600, color: '#3E246B' }}>Empresa: {item?.global}%</div>
                    )}
                </div>
            );
        }
        return null;
    };

    return (
        <ResponsiveContainer width="100%" height={300}>
            <RadarChart data={radarData} margin={{ top: 10, right: 20, bottom: 10, left: 20 }}>
                <PolarGrid radialLines stroke="#cfcfcf" strokeWidth={1.2} />
                <PolarAngleAxis dataKey="subject" tick={{ fontSize: 10, width: 120, fill: '#5b5b5b' }} />
                <PolarRadiusAxis
                    angle={30}
                    domain={[0, 100]}
                    ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    tick={{ fontSize: 10, fill: '#8c8c8c' }}
                    axisLine={{ strokeWidth: 1.5, stroke: '#bdbdbd' }}
                    tickLine={{ strokeWidth: 1 }}
                />
                {hasGlobal && (
                    <Radar
                        name="Empresa"
                        dataKey="global"
                        stroke="#3E246B"
                        strokeWidth={2}
                        strokeDasharray="5 5"
                        fill="rgba(62, 36, 107, 0.08)"
                        dot={{ r: 2.5, stroke: '#3E246B', strokeWidth: 1, fill: '#3E246B' }}
                    />
                )}
                <Radar
                    name="Individual"
                    dataKey="value"
                    stroke="#ff7a00"
                    strokeWidth={2.5}
                    fill="transparent"
                    dot={{ r: 3, stroke: '#ff7a00', strokeWidth: 1, fill: '#ff7a00' }}
                />
                <Tooltip content={<CustomTooltip />} />
            </RadarChart>
        </ResponsiveContainer>
    );
};

export default ResumeRadarSelfcare;
